// import {apiQuery, deleteCommand, findOneCommand, queueQuery, updateCommand} from './templates';
import './angular-documentHelper';
import './obto-data-components';
import * as _ from 'underscore';

import feather from 'feather-icons';

import 'tinymce/tinymce.min';
import 'tinymce/themes/modern';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/skins/lightgray/skin.min.css';
import 'angular-ui-tinymce';
import './obto-data-service';
window.feather = feather;

export class Document{
    constructor($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux, $scope) {
       this.$scope = $scope;
       this.$rootScope = $rootScope;
       this.$route = $route;
       this.values = $scope.values;
    }
    
    refresh(){
        this.$route.reload();
    }
    
    getRows(n){
        if (typeof n === "undefined" || !n) {
            return [];
        }
        return new Array(parseInt(n));
    }
    
    getColumns(n) {
        if (typeof n === "undefined" || !n) {
            return [];
        }
        return new Array(parseInt(n));
    };
    
    
    viewMode (m) {
        if (m === 1) {
            return 'Javascript';
        }
        
        if (m === 2) {
            return 'JSX';
        }
        
        if (m === 3) {
            return 'HTML';
        }
        
        if (m === 4) {
            return 'CSS';
        }
        
    };
    
    setDisplay(tab, docId, values) {
        let filter_value = docId;
        if (values[tab.filter]) {
            filter_value = values[tab.filter];
        }
        //If tab.filter is an object(key,value) then fvalue is ignored.
        //filter_data is deprecated
        return `<div id="${tab._id}" class="col-12"><jq-grid id="jqgridContainer-${tab._id}"
                     table="tab.on_collection" filter="tab.filter"
                     filter-data="tab.filter_data" column-model="tab.column_model"
                     fvalue=${filter_value} domain="domain" grid-options="gridOptions"
                     parentdiv="${tab._id}"
                     container=${tab._id}/></div>`;
    };
}

export class DocumentController extends Document {
    
    constructor($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux, $scope) {
        super($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux, $scope);
        this.docId = $scope.docId;
    }

}

DocumentController.$inject = [
    '$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$anchorScroll', 'OB', '$route', '$document', '$ngRedux', '$scope'
];

